import React from 'react'
import classnames from 'classnames'
import useDragAndDrop from '@Utils/UseDragAndDrop'
import Plus from '@Images/projects_table_new_project_plus.svg'
import FileDrop from '@Images/upload_file_drop.svg'

import './UploadArea.scss'

interface UploadAreaProps {
  readonly showAlert: boolean
  readonly bottomComponent?: React.ReactNode
  handleFileDrop(filesList: FileList): void
  openFileManager(): void
}

const UploadArea: React.FC<UploadAreaProps> = props => {
  const {
    showAlert,
    bottomComponent,
  } = props

  const { dragging, eventHandlers } = useDragAndDrop({ onDrop: props.handleFileDrop })

  const renderUploadOverlay = () => {
    return (
      <div className="UploadArea__overlay">
        <div className="UploadArea__overlay-center">
          <FileDrop />
          <div className="UploadArea__overlay-center-text">
            Drop files to upload them
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={classnames(
        'UploadArea',
        { 'UploadArea__dragging': dragging },
        { 'UploadArea__alert': showAlert },
      )}
      {...eventHandlers}
      onClick={props.openFileManager}
    >
      {!dragging && (
        <div className="UploadArea__center">
          <div className="UploadArea__center-icon">
            <Plus />
          </div>
          <div className="UploadArea__center-text">
            Click to upload or drag-and-drop
          </div>
          {bottomComponent}
        </div>
      )}
      {dragging && renderUploadOverlay()}
    </div>
  )
}

export default UploadArea
